import { Component, Input, OnInit } from '@angular/core';
import { NiUtils } from 'src/app/mockup/utils/ni';
import { CondicaoDocumentoEnum } from '../../models/condicao-documento-dto';
import { ParametrosPesquisaPagamento, TipoNivelPesquisa } from '../../models/parametros-pesquisa';

const MAPEAMENTO_PERIODO = {
  [CondicaoDocumentoEnum.PAGO]: "Arrecadação",
  [CondicaoDocumentoEnum.EMITIDO]: "Emissão",
  [CondicaoDocumentoEnum.AGENDADO]: "Débito"
};

const MAPEAMENTO_NIVEL_PESQUISA = {
  [TipoNivelPesquisa.DELEGACIA]: "Delegacia",
  [TipoNivelPesquisa.REGIAO]: "Região",
  [TipoNivelPesquisa.BRASIL]: "Brasil"
};

@Component({
  selector: 'via-parametros-pesquisa-pagamento',
  templateUrl: './parametros-pesquisa-pagamento.component.html',
  styleUrls: ['./parametros-pesquisa-pagamento.component.css']
})
export class ParametrosPesquisaPagamentoComponent implements OnInit {
  @Input() public atendimento: boolean = false;
  @Input() public set parametrosPesquisa(parametrosPesquisa: ParametrosPesquisaPagamento) {
    this._parametrosPesquisa = parametrosPesquisa;
    this.mapeamentoCampos = this.construirMapeamentoCampos();
    this.paresChavesCampos = this.construirParesChavesCampos();
  }

  public get parametrosPesquisa(): ParametrosPesquisaPagamento { return this._parametrosPesquisa; }

  public mapeamentoCampos: { [label: string]: string };
  public paresChavesCampos: string[][];

  public classesTh: string;
  public classesTd: string;

  private _parametrosPesquisa: ParametrosPesquisaPagamento;

  public ngOnInit(): void {
    this.classesTh = this.atendimento ? 'col-md-3' : 'col-md-2';
    this.classesTd = this.atendimento ? 'col-md-3' : 'col-md-4';
  }

  private construirMapeamentoCampos(): { [label: string]: string } {
    const nivelPesquisa = this.parametrosPesquisa.nivelPesquisa?.tipo ?? TipoNivelPesquisa.BRASIL;

    let valorNivelPesquisa = MAPEAMENTO_NIVEL_PESQUISA[nivelPesquisa];
    let valorNi = this.parametrosPesquisa.niSemDv?.ni;

    const valorBanco = this.parametrosPesquisa.banco != null ? `${this.parametrosPesquisa.banco?.codigo.toString().padStart(3, '0')} ${this.parametrosPesquisa.banco?.nome}` : null;
    const valorAgencia = this.parametrosPesquisa.agencia != null ? `${this.parametrosPesquisa.agencia?.codigo.toString().padStart(4, '0')} ${this.parametrosPesquisa.agencia?.nome}` : null;
    const valorDaraOnline = this.parametrosPesquisa.debitosNaoEfetivadosDaraOnline === true ? "Sim" : null;

    if (nivelPesquisa !== TipoNivelPesquisa.BRASIL) {
      valorNivelPesquisa += ` ${this.parametrosPesquisa.nivelPesquisa?.valor}`;
      
      if (nivelPesquisa === TipoNivelPesquisa.REGIAO) {
        valorNivelPesquisa += "a.";
      }
    }

    if (valorNi != null) {
      const tipo: "cpf" | "cnpj" = valorNi.length > 9 ? "cnpj" : "cpf";
      valorNi = NiUtils.formatarNi(NiUtils.obterNiCompleto(valorNi, tipo), tipo)
    }

    const chaveDataInicial = `Data de ${MAPEAMENTO_PERIODO[this.parametrosPesquisa.condicaoDocumento.codigo]} Inicial`;
    const chaveDataFinal = `Data de ${MAPEAMENTO_PERIODO[this.parametrosPesquisa.condicaoDocumento.codigo]} Final`;
    const chaveNi = this.parametrosPesquisa.niSemDv?.niInvalido ? "NI (Inválido)" : "NI";

    const mapeamento = {
      "Número do Pagamento": this.parametrosPesquisa.numeroPagamento,
      "Número do Documento": this.parametrosPesquisa.numeroDocumento,
      "Condição do Documento": this.parametrosPesquisa.condicaoDocumento?.descricao,
      "Tipo do Documento": this.parametrosPesquisa.tipoDocumento?.descricao,
      [chaveNi]: valorNi,
      "Receita": this.parametrosPesquisa.receita?.descricao,
      [chaveDataInicial]: this.parametrosPesquisa.periodoArrecadacao?.dataInicial?.toLocaleDateString(),
      [chaveDataFinal]: this.parametrosPesquisa.periodoArrecadacao?.dataFinal?.toLocaleDateString(),
      "Modalidade de Arrecadação": this.parametrosPesquisa.modalidadeArrecadacao?.descricao,
      "Natureza do Documento": this.parametrosPesquisa.naturezaDocumento?.descricao,
      "Documentos com débitos não efetivados pelo DARA Online": valorDaraOnline,
      "Faixa de Valor Inicial": this.parametrosPesquisa.faixaArrecadacao?.valorInicial?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      "Faixa de Valor Final": this.parametrosPesquisa.faixaArrecadacao?.valorFinal?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      "Banco": valorBanco,
      "Agência": valorAgencia,
      "Nível de Pesquisa": valorNivelPesquisa,
    };

    for (const key in mapeamento) {
      if (mapeamento[key] == null) {
        delete mapeamento[key];
      }
    }

    return mapeamento;
  }

  private construirParesChavesCampos(): string[][] {
    const pares: string[][] = [];
    const chaves = Object.keys(this.mapeamentoCampos);

    for (let i = 0; i < chaves.length; i += 2) {
      pares.push([chaves[i], chaves[i + 1]]);
    }

    return pares;
  }
}
